import { Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './Header';
import Home from './Home';
import Footer from './Footer';
import About from './pages/About';
import Editions from './pages/Editions';
import Contact from './pages/Contact';
import Media from './pages/Media';
import Donate from './pages/Donate';

export default function App() {
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/o-wydarzeniu' element={<About />} />
          <Route path='/edycje' element={<Editions />} />
          <Route path='/kontakt' element={<Contact />} />
          <Route path='/zostan-partnerem' element={<Donate />} />
          <Route path='/media' element={<Media />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
